var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('waktu-normal',{attrs:{"waktu":_vm.waktu}}),_c('waktu-live',{staticClass:"p-mt-6",attrs:{"waktu":_vm.waktu}}),_c('hr'),_c('div',[_vm._v("Setting waktu harus sesuai dengan timezone pada server")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }